<div data-testid="attachments-uploading-warning-dialog">
  <h2 mat-dialog-title>
    {{ 'WARNING' | translate }}

    <button
      [mat-dialog-close]="false"
      data-testid="close-btn"
      aria-label="close"
      mat-icon-button
      matSuffix
    >
      <mat-icon>close</mat-icon>
    </button>
  </h2>

  <div mat-dialog-content>
    <rs-font-light
      [innerHTML]="'SOME_DOCUMENTS_ARE_WAITING_TO_BE_UPLOADED_ARE_YOU_SURE_YOU_WANT_TO_LEAVE_THE_PAGE' | translate"
      class="mb-25px"
    />
  </div>

  <div mat-dialog-actions>
    <button
      [mat-dialog-close]="false"
      data-testid="no-btn"
      class="rs-btn--text"
      mat-button
    >
      {{ 'NO' | translate }}
    </button>

    <button
      [mat-dialog-close]="true"
      data-testid="yes-btn"
      class="rs-btn--primary position-relative"
      mat-button
    >
      {{ 'YES' | translate }}
    </button>
  </div>
</div>